import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { TeamTypeConfiguration } from "@common/ADAPT.Common.Model/organisation/team-type-configuration";
import { ORGANISATION_CONFIGURATION_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogWithDiscardConfirmationComponent } from "@common/ux/adapt-common-dialog/base-dialog-with-discard-confirmation.component/base-dialog-with-discard-confirmation.component";
import { ConfigArea } from "@org-common/lib/configuration/configuration-types";

@Component({
    templateUrl: "./change-team-appearance-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ChangeTeamAppearanceDialogComponent extends BaseDialogWithDiscardConfirmationComponent<Team | TeamTypeConfiguration> {
    public readonly dialogName = "ChangeTeamAppearance";
    public autoResolveData = this.entity;
    public entitiesToConfirm = [this.entity];

    public constructor(
        @Inject(ADAPT_DIALOG_DATA) public entity: Team | TeamTypeConfiguration,
        @Inject(ORGANISATION_CONFIGURATION_PAGE) private organisationConfigurationPageRoute: IAdaptRoute<any>,
    ) {
        super();
    }

    public isTeam(entity: Team | TeamTypeConfiguration): entity is Team {
        return entity instanceof Team;
    }

    public onConfigureOrganisationGroupTypesClicked() {
        this.organisationConfigurationPageRoute.gotoRoute(undefined, { section: ConfigArea[ConfigArea.Team] }).subscribe();
    }
}
